import * as React from "react";
import { cn } from "@/lib/utils";

// ponytail: 15px (text-body) per the design ramp. Below 16px iOS zooms on focus; the ramp wins.
function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        "border-input bg-card selection:bg-primary selection:text-primary-foreground placeholder:text-muted-foreground file:text-foreground text-body file:text-body-sm flex h-11 w-full min-w-0 rounded-[14px] border px-3.5 py-1 shadow-sm transition-[color,box-shadow] duration-[var(--duration-instant)] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50",
        "focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-[var(--ring-soft)] focus-visible:outline-none",
        "aria-invalid:border-destructive aria-invalid:ring-destructive/20 aria-invalid:border-[1.5px]",
        className,
      )}
      {...props}
    />
  );
}

export { Input };
